/*
  columns 新增参数 needMoment   自动转时间戳 默认为false 
  innerHeight 必传  滚动条产生的高度
  excelCallback  参数类型 function   不传默认不展示图标   
  pdfCallback   参数类型 function   不传默认不展示图标      
*/
import React, { Component } from 'react'
import {Empty, message, Pagination, Table} from 'antd';
import excel from './images/excel.svg'
import PDF from './images/PDF.svg'
import Guide from './Guide/index'
import moment from 'moment';
import Tools from "../../tools/Tools";
var language = localStorage.getItem('language')
export default class TableIOP extends Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: this.props.columns || []
    }
    this.setExpType = this.setExpType.bind(this)
  }
  componentWillReceiveProps(nextProps) {
    const { columns } = nextProps
    const columnsLength = columns.length
    const newColumns = columns.map((item, index) => {
      //日期特殊处理
      if (item.needMoment) {
        item.render = (text) => {
          if (!text) return
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      //最后一项固定右侧
      // if (index === columnsLength - 1) {
      //   item.fixed = 'right'
      // }
      //溢出隐藏 展示tooltip
      // item.ellipsis = {
      //   showTitle: true
      // }
      // 不支持最小宽度 默认最小宽度为150px
      !item.width && (item.width = '150px')
      //双击复制
      item.onCell = record => {
        return {
          onClick: event => { }, // 点击行
          onDoubleClick: event => {
            event.preventDefault()
            event.nativeEvent.stopImmediatePropagation();
            Tools.copy(event.target.innerText)
          },
          onContextMenu: event => { },
          onMouseEnter: event => { }, // 鼠标移入行
          onMouseLeave: event => { },
        };
      }
      return item
    })
    this.setState({
      columns: newColumns
    })
  }
  setExpType(expType) {
    window.localStorage.setItem('expType', expType)
    this.props.exportExcel()
  }

  handleExport(expType) {
    window.localStorage.setItem('expType', expType)
    const {columns,selectedRows} = this.props
    if(!selectedRows || !selectedRows.length) {
      this.props.exportExcel()
      return
    }
    console.log(this.props)
    console.log(this.refs.table)
    let header = [];
    let bodyRowList = [];
    columns.map(function (item) {
      if(item.dataIndex != 'operation') {
        header.push(item.title)
      }
    })
    selectedRows.map(function (item,index) {
      bodyRowList[index] = []
      columns.map(function (column) {
        if(column.column != 'operation') {
          bodyRowList[index].push({
            value:item[column['dataIndex']]||''
          })
        }
      })
    })
    let timeStamp = moment().format('YYYYMMDDHHmmss')
    console.log(header,bodyRowList)
    let model = {
      fileName:this.getExportName()+timeStamp,
      header,bodyRowList
    }
    let url = `/rest/excel/export?webVersion=3&expType=${expType}`
    Tools.fetch(url,'POST',model,function (data) {
      if(data.code == 0) {
        window.open(exportNoCacheData(data.data))
      } else {
        message.error(data.message)
      }
    })
  }

  getExportName() {
    const {exportType} = this.props
    let name = ''
    switch (exportType) {
      case 1:
        name = Strings.rs14525
            break
      case 2:
        name =  Strings.rs14526
            break
      case 3:
        name =  Strings.rs14527
            break
      case 4:
        name =  Strings.rs14528
            break
      case 5:
        name =  Strings.rs14529
            break
      default:
        name = ''
            break
    }
    return name
  }

  render() {
    const { count, pageSize, currentPage, onShowSizeChange, parentId, hiddenPagination, width, height, innerHeight, exportExcel, hideShadow, minHeight } = this.props;
    const { columns } = this.state
    let footer = <div className="new_app_pagination">
      {!hiddenPagination ? <Pagination
        {...this.props}
        style={{ display: 'inline-block' }}
        showSizeChanger
        pageSize={pageSize ? pageSize : 10}
        onChange={onShowSizeChange}
        onShowSizeChange={onShowSizeChange}
        current={currentPage}
        total={count}
        showTotal={function () {
          return `${Strings.rs10600} ${count} ${language == 'zh' ? '条' : ''}`
        }}
      /> : null}
      <div className='ww_icon_pagation'>
        {exportExcel && <div id='export_excel' onClick={() => { this.handleExport('excel') }}><img src={excel} /><span>{`Excel`}</span></div>}
        {exportExcel && <div onClick={() => { this.handleExport('pdf') }}><img src={PDF} /><span>{`PDF`}</span></div>}
      </div>

      {/* rs10600: "共", rs10601: "条",rs10330:  "记录",*/}
      {/* <span className='paganation_span'>{Strings.rs10600 + count + Strings.rs10601}</span> */}
    </div>;
    if (hiddenPagination && !exportExcel) {
      footer = null
    }
    let locale = {
      emptyText: <div className='empty_text' ><Empty description={<p>{Strings.rs12093}</p>} /></div>
    };
    console.log(columns)
    return <div className={`new_app_table_content ${hideShadow ? 'box_shadow_hidden ww_table_border' : ''}`} id={parentId} style={{ height: height || 'auto', width: width ? width : 'auto', minHeight: minHeight||'280px' }}>
      <Table ref="table" className={`new_app_table ${hideShadow ? 'ww_table_border' : ''}`} {...this.props} scroll={{ y: innerHeight - 109, x: '100%' }} locale={locale} pagination={false} columns={columns} />
      {footer}
      <Guide hidenMask={true}
          visible={exportExcel&& localStorage.getItem('export_guid')!=1}
          local_name='export_guid'
          stepArray={[{
            id: 'export_excel',
            content: Strings.rs10105,
            isTheme: true,
            isOnBottom:true,
          }]} />
    </div>
  }
}